import { Exit, Player } from "../objects";
import levelGoalKit from "./levelGoalKit";

class Level9 extends levelGoalKit {
  constructor() {
    super();
    this.name = "The floodgates";
    this.diamondsGoal = 10;
    // this.dwarfRun = false
  }

  get id() {
    return this.constructor.key
  }

  onInteractWith(el) {
    super.onInteractWith(el)
    
    if (el.isClass(Exit)) {
      this.onComplete();
    }
  }

  onAddElement(el) {
    if (el.isClass(Player)) {
      el.power = 1;
      el.hasPickaxe = true;
    }

  }

}

Level9.key = 'level_9'
export default Level9;
